import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-lead-email-4-preview',
  templateUrl: './lead-email-4.html',
 styleUrls: ['./lead-email-4.css']
})
export class LeadEmail4PreviewComponent {
  @Input() sitename: string = '';
  @Input() username: string = '';
  constructor(){
    console.log(this.sitename);
    console.log("sdasd",this.username);
    
    
  }
}